import {useEffect, useRef, useState} from "preact/hooks";

const candidates = (id) => [
    `https://i1.ytimg.com/vi_webp/${id}/mqdefault.webp`,
    `https://i1.ytimg.com/vi/${id}/mqdefault.jpg`,
    `https://i1.ytimg.com/vi/${id}/hqdefault.jpg`,
];

const isMissing = (img) => img.naturalWidth === 0 || img.naturalWidth <= 120;

export function YouTubeThumbnail({youtubeId, ...props}) {
    const [index, setIndex] = useState(0);
    const imgRef = useRef(null);
    const urls = candidates(youtubeId);

    useEffect(() => setIndex(0), [youtubeId]);

    const next = () => setIndex((i) => Math.min(i + 1, urls.length - 1));

    // With SSR the image can fail before hydration attaches the handlers.
    useEffect(() => {
        const img = imgRef.current;
        if (img && img.complete && isMissing(img)) next();
    }, [index, youtubeId]);

    return (
        <img
            {...props}
            ref={imgRef}
            src={urls[index]}
            onError={next}
            onLoad={(e) => isMissing(e.currentTarget) && next()}
        />
    );
}
